import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetWordCloud } from './useGetWordCloud'
import { WordCloudContent } from './WordCloudContent'

export const WordCloudComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetWordCloud(id, tileFilterSelections)

  return (
    <WordCloudContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function WordCloudComponentLoading() {
  return 'Loading...'
}
